import { reportError } from '@ringba/telemetry/rum';

export function apiUrlInterceptor($q, ngAuthSettings) {
  const base = ngAuthSettings.apiServiceBaseUri;

  return {
    request(config) {
      if (!config.url?.startsWith(base)) {
        return config;
      }

      const path = config.url.slice(base.length).split(/[?#]/)[0];
      const segments = path.split('/');
      const hasEmptyId = segments.some((segment, index) =>
        segment === 'null' || segment === 'undefined' || (segment === '' && index < segments.length - 1));

      if (!hasEmptyId) {
        return config;
      }

      reportError(new Error('Empty API path segment'), { method: config.method, path });
      return $q.reject({ config, status: -1, data: null, statusText: '' });
    },
  };
}
